import { render, staticRenderFns } from "./BilgiGuncelleme.vue?vue&type=template&id=685b5dd3&scoped=true"
import script from "./BilgiGuncelleme.vue?vue&type=script&lang=js"
export * from "./BilgiGuncelleme.vue?vue&type=script&lang=js"
import style0 from "./BilgiGuncelleme.vue?vue&type=style&index=0&id=685b5dd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685b5dd3",
  null
  
)

export default component.exports